import { render, staticRenderFns } from "./DescSection.vue?vue&type=template&id=7419e18c&scoped=true"
import script from "./DescSection.vue?vue&type=script&lang=js"
export * from "./DescSection.vue?vue&type=script&lang=js"
import style0 from "./DescSection.vue?vue&type=style&index=0&id=7419e18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7419e18c",
  null
  
)

export default component.exports